/* GENERATED by scripts/gen-data.mjs — film scene "f-families" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_FAMILIES: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "fr",
      "x": 14,
      "y": 14,
      "w": 612,
      "h": 270,
      "lKey": "films:f-families.items.fr.l"
    },
    {
      "k": "box",
      "id": "m1",
      "x": 28,
      "y": 40,
      "w": 176,
      "h": 46,
      "lKey": "films:f-families.items.m1.l",
      "sKey": "films:f-families.items.m1.s"
    },
    {
      "k": "bar",
      "id": "c1",
      "x": 222,
      "y": 48,
      "w": 150,
      "h": 7,
      "v": 0.1,
      "lKey": "films:f-families.items.c1.l"
    },
    {
      "k": "bar",
      "id": "l1",
      "x": 222,
      "y": 64,
      "w": 150,
      "h": 7,
      "v": 0.08,
      "lKey": "films:f-families.items.l1.l"
    },
    {
      "k": "note",
      "id": "n1",
      "x": 392,
      "y": 52,
      "lKey": "films:f-families.items.n1.l"
    },
    {
      "k": "box",
      "id": "m2",
      "x": 28,
      "y": 106,
      "w": 176,
      "h": 46,
      "lKey": "films:f-families.items.m2.l",
      "sKey": "films:f-families.items.m2.s"
    },
    {
      "k": "bar",
      "id": "c2",
      "x": 222,
      "y": 114,
      "w": 150,
      "h": 7,
      "v": 0.22,
      "lKey": "films:f-families.items.c2.l"
    },
    {
      "k": "bar",
      "id": "l2",
      "x": 222,
      "y": 130,
      "w": 150,
      "h": 7,
      "v": 0.18,
      "lKey": "films:f-families.items.l2.l"
    },
    {
      "k": "note",
      "id": "n2",
      "x": 392,
      "y": 118,
      "lKey": "films:f-families.items.n2.l"
    },
    {
      "k": "box",
      "id": "m3",
      "x": 28,
      "y": 172,
      "w": 176,
      "h": 46,
      "lKey": "films:f-families.items.m3.l",
      "sKey": "films:f-families.items.m3.s"
    },
    {
      "k": "bar",
      "id": "c3",
      "x": 222,
      "y": 180,
      "w": 150,
      "h": 7,
      "v": 0.16,
      "lKey": "films:f-families.items.c3.l"
    },
    {
      "k": "bar",
      "id": "l3",
      "x": 222,
      "y": 196,
      "w": 150,
      "h": 7,
      "v": 0.12,
      "lKey": "films:f-families.items.l3.l"
    },
    {
      "k": "note",
      "id": "n3",
      "x": 392,
      "y": 184,
      "lKey": "films:f-families.items.n3.l"
    },
    {
      "k": "box",
      "id": "m4",
      "x": 28,
      "y": 238,
      "w": 176,
      "h": 46,
      "lKey": "films:f-families.items.m4.l",
      "sKey": "films:f-families.items.m4.s"
    },
    {
      "k": "bar",
      "id": "c4",
      "x": 222,
      "y": 246,
      "w": 150,
      "h": 7,
      "v": 0.86,
      "lKey": "films:f-families.items.c4.l"
    },
    {
      "k": "bar",
      "id": "l4",
      "x": 222,
      "y": 262,
      "w": 150,
      "h": 7,
      "v": 0.78,
      "lKey": "films:f-families.items.l4.l"
    },
    {
      "k": "note",
      "id": "n4",
      "x": 392,
      "y": 250,
      "lKey": "films:f-families.items.n4.l"
    }
  ],
  "steps": [
    {
      "on": [
        "fr",
        "m1",
        "c1",
        "l1",
        "n1"
      ],
      "hot": [
        "m1",
        "c1"
      ],
      "capKey": "films:f-families.steps.0.cap"
    },
    {
      "on": [
        "fr",
        "m1",
        "c1",
        "l1",
        "n1",
        "m2",
        "c2",
        "l2",
        "n2"
      ],
      "hot": [
        "m2",
        "c2"
      ],
      "capKey": "films:f-families.steps.1.cap"
    },
    {
      "on": [
        "fr",
        "m1",
        "c1",
        "l1",
        "n1",
        "m2",
        "c2",
        "l2",
        "n2",
        "m3",
        "c3",
        "l3",
        "n3"
      ],
      "hot": [
        "m3",
        "c3"
      ],
      "capKey": "films:f-families.steps.2.cap"
    },
    {
      "on": [
        "fr",
        "m1",
        "c1",
        "l1",
        "n1",
        "m2",
        "c2",
        "l2",
        "n2",
        "m3",
        "c3",
        "l3",
        "n3",
        "m4",
        "c4",
        "l4",
        "n4"
      ],
      "hot": [
        "m4",
        "c4",
        "l4"
      ],
      "capKey": "films:f-families.steps.3.cap"
    }
  ]
};
